import { render } from "./Preloader.vue?vue&type=template&id=0e20e3d7"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=0e20e3d7&lang=css"

import exportComponent from "C:\\Users\\TATS\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\tsg-exec\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__